import React, { Component } from "react";
import deepcopy from "rfdc";
import InlineVendorPartCostDisplay from "./components/InlineVendorPartCostDisplay";
import InlineVendorPartCostForm from "./forms/InlineVendorPartCostForm";
import { validateVendorPartCost } from "./utils/utils";

const PAGE_MODES = {
    VIEW_VENDOR_PART_COST: "VIEW_VENDOR_PART_COST",
    EDIT_VENDOR_PART_COST: "EDIT_VENDOR_PART_COST",
}

const FORM_DATA_NAMES_BY_MODE = {
    EDIT_VENDOR_PART_COST: "vendorPartCostFormData",
}


class InlineVendorPartCostContainer extends Component {

    // Initialize

    constructor(props) {
        super(props)

        let defaultMode = this.props.formMode || PAGE_MODES.VIEW_VENDOR_PART_COST

        const vendorPartCost = deepcopy()(this.props.vendorPartCost)
        const isNewAddition = vendorPartCost.__new__ === true

        if (isNewAddition) {
            defaultMode = PAGE_MODES.EDIT_VENDOR_PART_COST
            delete vendorPartCost.__new__
        }

        this.state = {
            removed: false,
            isNewAddition: isNewAddition,
            vendorPartCostData: vendorPartCost,
            vendorPartCostFormData: deepcopy()(vendorPartCost),
            mode: defaultMode,
        }
    }

    // Form helpers

    updateFormData = (formName, fieldName, fieldValue) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState[formName][fieldName] = fieldValue
            return updatedState
        })
    }

    switchFormMode = (mode) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState.mode = mode
            return updatedState
        })
    }

    switchToDisplay = () => {
        this.setState((state, props) => {
            let updatedState = state

            // Reset primary form data
            updatedState[FORM_DATA_NAMES_BY_MODE[state.mode]] = deepcopy()(this.props.vendorPartCost)
            return updatedState
        })
        this.switchFormMode(PAGE_MODES.VIEW_VENDOR_PART_COST)
    }

    switchToPrimaryForm = () => {
        this.switchFormMode(PAGE_MODES.EDIT_VENDOR_PART_COST)
    }

    softDeleteVendorPartCost = (json) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState.removed = true
            return updatedState
        })
    }

    // Handle Actions

    handleActionRequest = (action) => {
        switch (action) {
            case "VENDOR_PART_COST_EDIT":
                this.switchToPrimaryForm()
                break
            case "VENDOR_PART_COST_SAVE":
                const { isValid, errors } = validateVendorPartCost(this.props.allVendorPartCosts, this.state.vendorPartCostFormData, this.props.index)

                if (isValid) {
                    this.setState((state, props) => {
                        let updatedState = state

                        delete state.vendorPartCostFormData.errors
                        updatedState.vendorPartCostData = state.vendorPartCostFormData

                        this.props.updateVendorPartCost(updatedState.vendorPartCostData)

                        return updatedState
                    })
                    this.switchFormMode(PAGE_MODES.VIEW_VENDOR_PART_COST)
                }
                else {
                    this.setState((state, props) => {
                        let updatedState = state
                        updatedState.vendorPartCostFormData.errors = errors
                        return updatedState
                    })
                }
                break
            case "VENDOR_PART_COST_DELETE":
                this.props.deleteVendorPartCost(this.state.vendorPartCostData)
                this.softDeleteVendorPartCost()
                break
            case "VENDOR_PART_COST_CANCEL_EDITS":
                this.switchToDisplay()
                break
            default:
                console.error(`No action handler exists for action "${action}".`)
        }
    }

    // Render

    render = () => {
        const { currencySymbol } = this.props

        if (!this.state.removed) {
            if (this.state.mode === PAGE_MODES.VIEW_VENDOR_PART_COST) {
                return <InlineVendorPartCostDisplay
                    vendorPartCost={this.state.vendorPartCostData}
                    requestAction={this.handleActionRequest}
                    currencySymbol={currencySymbol}
                />
            }
            else if (this.state.mode === PAGE_MODES.EDIT_VENDOR_PART_COST) {
                return <InlineVendorPartCostForm
                    vendorPartCost={this.state.vendorPartCostFormData}
                    isNewAddition={this.state.isNewAddition}
                    onFormDataChange={(fieldName, fieldValue) => this.updateFormData(FORM_DATA_NAMES_BY_MODE[this.state.mode], fieldName, fieldValue)}
                    requestAction={this.handleActionRequest}
                    currencySymbol={currencySymbol}
                />
            }
            else {
                return (
                    <div className="data-panel-container data-panel-container--with-margin">
                        <div className="data-panel" aria-label="Unknown Form Mode">
                            <div className="data-panel__form">
                                <p className="data-panel__form__caption">An unhandled form mode was supplied.</p>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        else {
            return null
        }
    }
}

export default InlineVendorPartCostContainer;
